<template>
  <div
    ref="headerRef"
    :style="styleThemeVars"
    class="consumer-header"
  >
    <BaseHeader
      :header-title="config.centerLabel || fileInfo?.name"
      :locale="(locale as any)"
      :app-extension-header="true"
      :disabled-inject="true"
      :is-mobile="isMobile"
      :class="hideCls"
      @close="handleClose"
    >
      <template #headerRight>
        <div />
      </template>
    </BaseHeader>
  </div>
</template>

<script
  lang="ts"
  setup
>
import {
  computed,
  reactive,
  ref,
  watch,
} from 'vue'
import { useI18n, toRefs } from '#imports'
import BaseHeader from '@pikpak_web_player/components/controller/Header.vue'
import { useLayout } from '~/store/layout'
import { useElementSize } from '@vueuse/core'
import type {
  IConsumerEventShowHeaderParams,
  IFileInfo,
  THeaderOperates,
} from './consumer.type'

const emits = defineEmits<{
  close: []
  operate: [type: THeaderOperates, event: MouseEvent]
  heightUpdate: [h: number]
}>()

interface Props {
  fileInfo?: IFileInfo
}

defineProps<Props>()

const { locale } = useI18n()
const { isMobile } = toRefs(useLayout())
const headerRef = ref()

const { height } = useElementSize(headerRef)

const config = reactive<IConsumerEventShowHeaderParams>({})

const hideCls = computed(() => config.hidePosition?.map(pos => `hide-${pos}`))
const styleThemeVars = computed(() => {
  const { styleTheme = {} } = config
  return {
    '--consumer-hd-z-index': styleTheme.zIndex || 1000,
    '--text-normal-color': styleTheme.textColor || '#fff',
    '--button-hover-color': styleTheme.textHoverColor || '#306EFF',
  }
})

const updateConfig = (params?: IConsumerEventShowHeaderParams) => {
  Object.assign(config, params || {})
}

const handleClose = () => {
  emits('close')
}

watch(height, val => {
  emits('heightUpdate', val)
})

defineExpose({ updateConfig })
</script>

<style
  lang="less"
  scoped
>
.consumer-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--consumer-hd-z-index, 1000);
  width: 100%;
  height: 54px;
  padding: 0 24px;
  background: transparent;
  pointer-events: none;
}
</style>
